import type { AssistantTurnMeta } from "@maestros/contracts";

/** Server wall time for the turn, including waits; never infer missing legacy timestamps. */
export function turnTiming(turn: AssistantTurnMeta | null | undefined, now: number): { milliseconds: number; active: boolean } | null {
  if (!turn?.started_at) return null;
  const start = Date.parse(turn.started_at);
  const active = turn.state === "running" && !turn.completed_at;
  const end = turn.completed_at ? Date.parse(turn.completed_at) : active ? now : NaN;
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return null;
  return { milliseconds: end - start, active };
}

export function formatTurnDuration(milliseconds: number): string {
  const seconds = Math.floor(milliseconds / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m ${seconds % 60}s`;
}
